import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, className, ...props }) => {
  if (!IconComponent) {
    return null;
  }

  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;